import * as yup from "yup";

declare module "yup" {
  export interface StringSchema {
    validateBSB(message?: string): StringSchema;
  }
}

export const BSB_LENGTH = 6;
const bsbPattern = new RegExp(`^\\d{${BSB_LENGTH}}$`);

yup.addMethod<yup.StringSchema>(
  yup.string,
  "validateBSB",
  function (message = "Please, provide valid BSB") {
    return this.test(
      "validate-bsb",
      message,
      function validateBSB(value?: string) {
        if (!value) {
          return true;
        }

        return bsbPattern.test(value);
      }
    );
  }
);
